<template>
  <component :is="tagIs">
    <span class="detail-title">Nutrition Facts</span>
    <span class="detail-value -estimate">
      <icon-button
        type="button"
        class="-ico-only -no-container"
        :icon="hidden ? 'visibility' : 'visibility_off'"
        label="Recipe Nutrition Facts"
        :aria-expanded="hidden ? 'false' : 'true'"
        :aria-controls="expanderId"
        @click-action="handleVisibilityToggle"
      />
    </span>
    <outside-click
      :display="'inline'"
      ignore-query-selector=".detail-value.-estimate"
      :disabled="hidden"
      @outside-click-action="closeVisibility"
    >
      <div
        v-show="!hidden"
        :aria-hidden="hidden ? 'true' : 'false'"
        class="chelp-container"
        :class="{ 'chelp-open': !hidden }"
      >
        <div
          class="chelp-close"
          tabindex="0"
          role="button"
          aria-label="Close"
          @click="closeVisibility"
          @keyup.enter="closeVisibility"
        >
          <i class="material-symbols-outlined" aria-hidden="true">close</i>
        </div>
        <div :id="expanderId" role="tooltip">
          <slot />
        </div>
      </div>
    </outside-click>
  </component>
</template>

<script>
import IconButton from '@/components/buttons/icon-button.vue'
import OutsideClick from '@/components/tool-tips/outside-click.vue'

/**
 * Custom contextual help expander for recipe nutrition facts.
 */
export default {
  name: 'RecipeMacros',
  components: { IconButton, OutsideClick },
  props: {
    tagIs: {
      type: String,
      default: 'li',
    },
  },
  data() {
    return {
      hidden: true,
    }
  },
  computed: {
    expanderId() {
      return `recipe-macros-expander`
    },
  },
  methods: {
    handleVisibilityToggle() {
      this.hidden = !this.hidden
    },

    closeVisibility() {
      this.hidden = true
    },
  },
}
</script>
